export const NEW_MAIN_PAGE_EXPERIMENT = 'bx_mobile_bx687_new_mainpage';
export const DESKTOP_REDESIGN_RECOMMENDATIONS_EXPERIMENT = 'bx_desktop_bx1106_redesign_recs_mainpage';

export const EXPERIMENTS: string[] = [NEW_MAIN_PAGE_EXPERIMENT, DESKTOP_REDESIGN_RECOMMENDATIONS_EXPERIMENT];
